<template>
    <div id="app">
        <Preloader />
        <router-view></router-view>
    </div>
</template>

<style>
</style>

<script>
import Utils from './js/helpers/Utils';
import Preloader from './components/layouts/preloader';
import GoogleTagManager from './js/thirdparty/analytics/GoogleTagManager';
import GTM from './js/thirdparty/analytics/GTM';

export default {
    name: "App",
    components: { Preloader },
    mounted() {
        setTimeout(() => {
            Utils.loadHeader();

            // TODO: Universal Analytics end support on July 1, 2023, this is candidate for removal
            let googleTagManager = new GoogleTagManager();
            googleTagManager.execute();

            // GTM that supports GA4 custom event triggers
            let gtm = new GTM();
            gtm.execute();
        }, 60);
    },
    watch: {
      '$route': {
        handler: (to) => {
            document.title = to.meta.title || '英辞郎 on the WEB Pro ショップ';
            GoogleTagManager.triggerEvent(GoogleTagManager.EVENT_PAGEVIEW, document.location.href, to.path, document.title);
        },
        immediate: true
      }
    },
};
</script>
